// Styles for MapClustersComponent go here.
import styled from 'styled-components';

export const StyledMapClustersComponent = styled.div``;
